<div class="wrapper">
  <div class="bar1"></div>
  <div class="bar2"></div>
</div>
